import useSWR from 'swr'

import { CountriesResponse } from './types'
import { API } from '@/api/endpoints'

/**
 * GET All
 */
export const useCountries = () => {
  const { data, error, isLoading, mutate } = useSWR<CountriesResponse>(API.COUNTRIES)

  return {
    collection: data?.data,
    isLoading,
    error,
    mutate
  }
}
